/**
 * Use v3 search endpoint as XP on logged out discover page, and feature toggle for logged in.  * The endpoint call is gated by this setting.
 */
export const ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731 = 'ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731';
